export const USER_ACTIVITY_TIMEOUT = 10 * 60 * 1000;
export const FINAL_TIMEOUT = 3 * 60 * 1000;
